import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] rounded-md flex flex-col h-full min-h-[500px] shadow-lg overflow-hidden" }
const _hoisted_2 = { class: "flex-grow flex flex-col px-[20px] md:px-[25px] pb-[20px] md:pb-[25px]" }
const _hoisted_3 = {
  key: 0,
  class: "flex-grow flex justify-center items-center py-8"
}
const _hoisted_4 = {
  key: 1,
  class: "flex-grow flex flex-col justify-center items-center py-5"
}
const _hoisted_5 = { class: "text-danger-500" }
const _hoisted_6 = {
  key: 2,
  class: "flex-grow flex flex-col justify-center items-center py-5"
}
const _hoisted_7 = {
  key: 3,
  class: "flex-grow overflow-y-auto mb-4 pr-1"
}
const _hoisted_8 = { class: "flex items-start justify-between mb-2" }
const _hoisted_9 = { class: "font-medium text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_10 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_11 = { class: "text-gray-700 dark:text-gray-300 whitespace-pre-line" }
const _hoisted_12 = { class: "mt-auto" }
const _hoisted_13 = { class: "flex justify-end mt-3" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-full bg-primary-500 shadow-md p-4 mb-5" }, [
      _createElementVNode("div", { class: "max-w-[200px] mx-auto" }, [
        _createElementVNode("h3", { class: "text-lg font-medium text-center text-white" }, "Property Notes")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-500 opacity-75" }, null, -1)
          ])))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-danger-500 text-xl mb-2" }, [
                _createElementVNode("i", { class: "ri-error-warning-line" })
              ], -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.error), 1)
            ]))
          : (_ctx.notes.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[4] || (_cache[4] = [
                _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400 mb-3" }, "No notes have been added yet.", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: note.id,
                    class: "mb-4 p-3 bg-white dark:bg-[#172036] border border-gray-100 dark:border-[#172036] rounded-2xl shadow-md"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getDisplayName(note.userid)), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formatDate(note.created_at)), 1)
                    ]),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(note.note), 1)
                  ]))
                }), 128))
              ])),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newNote) = $event)),
          rows: "3",
          class: "w-full px-3 py-2 border border-gray-200 dark:border-[#172036] rounded-md bg-white dark:bg-[#0c1427] text-gray-700 dark:text-gray-300 focus:border-primary-500 focus:outline-none resize-none",
          placeholder: "Add a note..."
        }, null, 512), [
          [_vModelText, _ctx.newNote]
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNote && _ctx.addNote(...args))),
            disabled: _ctx.isSubmitting || !_ctx.newNote.trim(),
            class: "px-4 py-2 bg-primary-500 text-white rounded-md font-medium hover:bg-primary-400 transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary-500"
          }, _toDisplayString(_ctx.isSubmitting ? 'Adding...' : 'Add Note'), 9, _hoisted_14)
        ])
      ])
    ])
  ]))
}